export function addPageAction(actionName, attributes = {}) {
  if (typeof window === "undefined") return;
  window.newrelic?.addPageAction(actionName, attributes);
}
